import type { Customer } from '../../../../../../selectors/select-customer/types';
import type { Price } from '../../../../../../models/price';

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  currency: 'AUD',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: 'currency',
});

const calculatePriceDifference = (prices: (Price | undefined)[], frequency: Customer['frequency']): string | null => {
  if (prices.length !== 2) {
    return null;
  }

  const [baseAmount, upgradeAmount] = [prices[0]?.amount[frequency], prices[1]?.amount[frequency]];
  if (!baseAmount || !upgradeAmount) {
    return null;
  }

  const baseCents = Math.round(Number(baseAmount) * 100);
  const upgradeCents = Math.round(Number(upgradeAmount) * 100);

  return currencyFormatter.format(Math.abs(upgradeCents - baseCents) / 100);
};

export default calculatePriceDifference;
